import { useIsVendorMasqueradeAvailable } from '@aegix/auth-organization';
import { useVendorOnboardingOrganizations } from './queries';

export interface CrossOrgAffiliationsResult {
  hasCrossOrgAffiliations: boolean;
  canSwitchOrg: boolean;
  isLoading: boolean;
}

/**
 * Returns true if the current user has cross-org affiliations (2 or more
 * accessible/affiliated organizations) or vendor masquerade availability.
 *
 * Rules:
 * - Plain users (non-vendor) with site assignments across multiple orgs (or home org + site orgs)
 *   have cross-org affiliations (`orgs.length >= 2`) and need an org switcher.
 * - Single-org plain users do not receive an org switcher.
 * - Vendor masquerade users always have org switching enabled.
 */
export function useHasCrossOrgAffiliations(): CrossOrgAffiliationsResult {
  const isVendorUser = useIsVendorMasqueradeAvailable();
  const { data: orgs, isLoading } = useVendorOnboardingOrganizations();

  const count = orgs?.length ?? 0;
  const hasCrossOrgAffiliations = count >= 2;
  const canSwitchOrg = isVendorUser || hasCrossOrgAffiliations;

  return {
    hasCrossOrgAffiliations,
    canSwitchOrg,
    isLoading,
  };
}
